import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.scss';
import MainApp from './main';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <MainApp />
  </React.StrictMode>
);